/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Toggle_TitleInputs */

const es_walkthrough_sidebar_toggle_title = /** @type {(inputs: Walkthrough_Sidebar_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar / Ocultar Sidebar`)
};

const en_walkthrough_sidebar_toggle_title = /** @type {(inputs: Walkthrough_Sidebar_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Sidebar`)
};

/**
* | output |
* | --- |
* | "Toggle Sidebar" |
*
* @param {Walkthrough_Sidebar_Toggle_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_toggle_title = /** @type {((inputs?: Walkthrough_Sidebar_Toggle_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Toggle_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_toggle_title(inputs)
	return en_walkthrough_sidebar_toggle_title(inputs)
});
export { walkthrough_sidebar_toggle_title as "walkthrough.sidebar_toggle_title" }